import React, { useEffect, useState } from "react";
import locat from "../../assets/images/location.svg";
import Star from "../../assets/images/star.svg";
import Clock from "../../assets/images/Vector.svg";
import axiosInstance from "../../axiosConfig/axios";
import Loading from "../../components/loading/loading";
import feastLogo from "../../assets/images/logo.svg";

const RestaurantHeader = ({ restaurantInfoData }) => {
  const [isScrolling, setIsScrolling] = useState(false);

  // useEffect(() => {
  //   const handleScroll = () => {
  //     if (window.scrollY > 0) {
  //       setIsScrolling(true);
  //     } else {
  //       setIsScrolling(false);
  //     }
  //   };

  //   // Attach the scroll event listener
  //   window.addEventListener("scroll", handleScroll);

  //   // Clean up the event listener on component unmount
  //   return () => {
  //     window.removeEventListener("scroll", handleScroll);
  //   };
  // }, []);

  const {
    name,
    business_name,
    address,
    distance,
    rating,
    logo,
    open_time,
    close_time,
    categories,
  } = restaurantInfoData;
  

  const menu_categories = categories?.split(",");

  return (
    <div className="contain">
      <div className={isScrolling ? `noScroll` : `scroll`}>
        <div className="image-container">
          <img src={logo?logo:feastLogo} alt="logo" className="logo" />
        </div>
        <h3>
          {business_name} ({name}){" "}
        </h3>
      </div>

      <div className={isScrolling ? `main-header` : `noMain-header`}>
        <img src={logo} alt="logo" className="logo2" />

        <h3>{name}</h3>
      </div>

      <div className={isScrolling ? `none-main-details` : `main-details`}>
        <div className="location">
          <p>{address}</p>
        </div>

        <div className="details">
          <div className="address">
            <img src={locat} alt="location" />
            <p>{distance}</p>
          </div>
          <div className="divider"></div>
          <div className="rating">
            <img src={Star} alt="star" />
            <p>{rating}</p>
          </div>
          <div className="divider"></div>
          <div className="clock">
            <img src={Clock} alt="clock" />

            <p>
              من {open_time} إلى {close_time}
            </p>
          </div>
        </div>

        <div className="menu-categories">
          {menu_categories?.length > 0
            ? menu_categories?.map((category) => (
                <div key={category} className="category">
                  {category}
                </div>
              ))
            : null}
        </div>
      </div>
    </div>
  );
};

export default RestaurantHeader;
